import React from "react";
import background from "../../assets/images/updated-background.png";
import logo from "../../assets/svgs/ArcSpan-Logo2.svg";
import PasswordRecoveryComponent from "../../components/password-recovery/index";

function PasswordRecovery() {
	return (
		<div
			className="loginPage"
			style={{
				backgroundImage: `url(${background})`,
				backgroundRepeat: "no-repeat",
				backgroundSize: "cover",
				backgroundPosition: "center",
				height: "100vh",
			}}
		>
			<div className="login-header container">
				<img
					className="login-logo"
					src={logo}
				/>
			</div>
			<div className="login-container container">
				<div className="left-container">
					<div className="text strong">
						Take control of your <div>Audience Monetization</div>
					</div>
				</div>
				<div className="right-container">
					<PasswordRecoveryComponent />
				</div>
			</div>
		</div>
	);
}

export default PasswordRecovery;
